import { ViewModel } from './_vm'

import FormStore from './store/_form-store'
import UiStore from '../store/_ui-store'
import SelectTemplate from './_selectTemplate'

/**
 * GadgetPeopleButton // セレクトのjs
 *
 * @returns {undefined}
 */
export class GadgetPeopleButton extends ViewModel {
  constructor($element, controller) {
    super(GadgetPeopleButton.name(), $element, controller)
    this.formName = this.$element.attr('name')
    this.disableClass = 'disable'
    // イベントの登録
    // this.$element.on('change', () => this.select())
    this.on(`GadgetPeopleButton`, () => this.render())
    this.on(`GadgetPeopleButton:countCheck`, () => this.countCheck())
    this.$element.find('.plus_count_people[name=' + this.formName + ']').on('click', () => this.plusClick())
    this.$element.find('.minus_count_people[name=' + this.formName + ']').on('click', () => this.minusClick())

    // UiStore.updateData(`room1age6r`, 0)
    // UiStore.updateData(`room1age0r`, 0)
    this.buttonDisable('room1age20r')
    this.buttonDisable('room2age20r')
    this.buttonDisable('room3age20r')
    this.buttonDisable('room4age20r')
    this.buttonDisable('room5age20r')
    // this.on(`GadgetPeopleButton:Room`, () => this.roomRender())
    // this.on(`GadgetPeopleButton:${this.formName}`, () => this.render())
    // this.click(``, () => this.click())
    // this.option()

    // 様子見
    this.render()
    // this.roomRender()
  }

  static name() {
    return 'GadgetPeopleButton'
  }

  static className() {
    return '.js-kaigai-gadget-people-button'
  }

  plusClick() {
    console.log('plusClick')
    // console.log('element', this.$element)
    if ($(this.$element).find('.plus_count_people.disable[name=' + this.formName + ']').length > 0) return
    this.target = this.formName.replace('Plus', '').replace('Minus', '')
    // console.log('this.target', this.target)
    const target = this.$element.parent().find('.' + this.target)
    // console.log('target', target)
    const targetNum = target.data(this.target)
    // console.log('targetNum', targetNum)
    const targetNewNum = targetNum + 1
    // console.log('targetNewNum', targetNewNum)
    target.data(this.target, targetNewNum)
    target.html(targetNewNum)
    FormStore.updateData(this.target, targetNewNum)
    UiStore.updateData(this.target, targetNewNum)
    UiStore.updateData(this.formName, targetNewNum)
    UiStore.updateData(`room0people`, targetNewNum)
    console.log('plusClick', this.formName, UiStore.getData(this.formName, 0))
    // this.trigger('tourDetailRoomAllocation')
    const clickable = this.countCheck()
    this.buttonDisable(this.formName)

    // console.log('clickable', clickable)
    // console.log('room1people更新済み', UiStore.getData(`room0people`))
    // console.log('target更新済み', target.data(this.target))
    $(this).addClass(this.disableClass)
  }

  minusClick() {
    if ($(this.$element).find('.minus_count_people.disable[name=' + this.formName + ']').length > 0) return
    this.target = this.formName.replace('Plus', '').replace('Minus', '')
    const target = this.$element.parent().find('.' + this.target)
    const targetNum = target.data(this.target)
    const targetNewNum = targetNum - 1
    target.data(this.target, targetNewNum)
    target.html(targetNewNum)
    FormStore.updateData(this.target, targetNewNum)
    UiStore.updateData(this.target, targetNewNum)
    UiStore.updateData(`room0people`, targetNewNum)

    // this.trigger('tourDetailRoomAllocation')
    const clickable = this.countCheck()
    this.buttonDisable(this.formName)
    // console.log('plusDisable', UiStore.getData(`plusDisable`))
    // console.log('minusDisable', UiStore.getData(`minusDisable`))

    // console.log('clickable', clickable)
    // console.log('room1people更新済み', UiStore.getData(`room0people`))
    // console.log('target更新済み', target.data(this.target))
  }

  countCheck() {
    const roomNum = FormStore.getData('roomNum', 0)
    let adult = 0
    let child = 0
    let inf = 0
    let totalNum = 0
    let totalAdult = 0
    let totalChild = 0
    let totalInf = 0
    const people = UiStore.getData(`room0people`, 0)
    UiStore.updateData(`allNum`, 0)
    if (roomNum < 5) {
      const deleteRoomNum = roomNum + 1
      for (let i = deleteRoomNum; i <= 5; i++) {
        UiStore.updateData(`room${i}age20r`, 0)
        UiStore.updateData(`room${i}age6r`, 0)
        UiStore.updateData(`room${i}age0r`, 0)
        console.log('deleteRoomNum', i)
        console.log('deleteRoomNum:age20r', UiStore.getData(`room${i}age20r`, 0))
        console.log('deleteRoomNum:age6r', UiStore.getData(`room${i}age6r`, 0))
        console.log('deleteRoomNum:age0r', UiStore.getData(`room${i}age0r`, 0))
      }
    }
    for (let i = 1; i <= roomNum; i++) {
      if (UiStore.getData(`room${i}age20r`, 0) === 0) {
        const num = i === 1 ? 2 : 1
        const target = $(`.room${i}age20r`)
        target.data(this.target, num)
        target.html(num)
        UiStore.updateData(`room${i}age20r`, num)
      }

      adult = UiStore.getData(`room${i}age20r`, 0)
      child = UiStore.getData(`room${i}age6r`, 0)
      inf = UiStore.getData(`room${i}age0r`, 0)
      const target20 = $(`.room${i}age20r`)
      target20.data(`room${i}age20r`, adult)
      target20.html(adult)
      const target6 = $(`.room${i}age6r`)
      target6.data(`room${i}age6r`, child)
      target6.html(child)
      const target0 = $(`.room${i}age0r`)
      target0.data(`room${i}age0r`, inf)
      target0.html(inf)

      totalNum = adult + child + inf
      totalAdult = totalAdult + adult
      totalChild = totalChild + child
      totalInf = totalInf + inf
      UiStore.updateData(`plusDisable`, 1)
      console.log('room', i)
      console.log('adult', adult)
      console.log('child', child)
      console.log('inf', inf)

      if (adult === inf) {
        this.buttonDisable(`room${i}age0r`)
      }
      const allNum = UiStore.getData(`allNum`, 0) + totalNum
      UiStore.updateData(`allNum`, allNum)
      this.controller.action('lockRooms')
      console.log('countCheck')
    }

    UiStore.updateData(`totalAdult`, totalAdult)
    UiStore.updateData(`totalChild`, totalChild)
    UiStore.updateData(`totalInf`, totalInf)
    this.trigger('TopRoomChange:render')
    this.trigger('TopRoomsInfo:render')
    const allNum = UiStore.getData(`allNum`, 9)

    // totalが作業中
    if (allNum >= 9) {
      UiStore.updateData(`plusDisable`, true)
    } else {
      UiStore.updateData(`plusDisable`, false)
    }
    if (allNum <= 1) {
      UiStore.updateData(`minusDisable`, true)
    } else {
      UiStore.updateData(`minusDisable`, false)
    }
    if (roomNum >= 5 || allNum >= 9) {
      UiStore.updateData(`roomPlusDisable`, true)
    } else {
      UiStore.updateData(`roomPlusDisable`, false)
    }
    if (roomNum <= 1) {
      UiStore.updateData(`roomMinusDisable`, true)
    } else {
      UiStore.updateData(`roomMinusDisable`, false)
    }
    console.log('allNum', UiStore.getData(`allNum`, 0))
    // console.log('totalNum', UiStore.getData(`totalNum`, 0))
    return (totalNum > 1 && totalNum < 9 && inf <= adult) || adult >= 1
  }

  buttonDisable(roomName = this.formName) {
    console.log('buttonDisable', roomName, UiStore.getData(roomName, 0))
    const allRooms = UiStore.getData('allRooms', {})
    allRooms[[roomName]] = UiStore.getData(roomName, 0)
    // allRooms.push({ key: roomName, value: UiStore.getData(roomName, 0) })
    UiStore.updateData('allRooms', allRooms)
    console.log('allRooms', UiStore.getData('allRooms', {}))
    if (UiStore.getData(`plusDisable`, false) === true) {
      $('.plus_count_people').addClass(this.disableClass)
      $('.plus_count').addClass(this.disableClass)
    } else {
      $('.plus_count_people').removeClass(this.disableClass)
      $('.plus_count').removeClass(this.disableClass)
    }
    if (UiStore.getData(`minusDisable`, false) === true) {
      $('.minus_count_people').addClass(this.disableClass)
      console.log(1)
    } else {
      if (UiStore.getData(roomName, 0) !== 0) {
        $('.minus_count_people[name=' + roomName + ']').removeClass(this.disableClass)
        console.log(2)
      }
    }

    if (UiStore.getData(roomName, 0) === 0) {
      $('.minus_count_people[name=' + roomName + ']').addClass(this.disableClass)
      console.log(3, roomName)
    } else {
      $('.minus_count_people[name=' + roomName + ']').removeClass(this.disableClass)
      console.log('3-2', roomName)
    }
    if (UiStore.getData(roomName, 0) !== 0) {
      $('.minus_count_people[name=' + roomName + ']').removeClass(this.disableClass)
      console.log(4)
    }

    if (roomName.indexOf('20') !== -1 && UiStore.getData(roomName, 0) === 1) {
      $('.minus_count_people[name=' + roomName + ']').addClass(this.disableClass)
      console.log(5, roomName)
    }
    this.controller.action('lockRooms')

    if (UiStore.getData(`roomPlusDisable`, false) === true) {
      $('.plus_count').addClass(this.disableClass)
    } else {
      $('.plus_count').removeClass(this.disableClass)
    }
    if (UiStore.getData(`roomMinusDisable`, true) === true) {
      $('.minus_count').addClass(this.disableClass)
    } else {
      $('.minus_count').removeClass(this.disableClass)
    }
    console.log('plusDisable', UiStore.getData(`plusDisable`))
    console.log('minusDisable', UiStore.getData(`minusDisable`))
  }
  //   peoplePlusClick() {
  //     console.log('peoplePlusClick')
  //     // this.target = this.formName.replace('Plus', '').replace('Minus', '')
  //     // console.log('target', this.target)
  //     // const target = this.$element.parent().find('#' + this.target)
  //     // const targetNum = target.data(this.target)
  //     // const targetNewNum = targetNum + 1
  //     // target.data(this.target, targetNewNum)
  //     // target.html(targetNewNum)
  //     // FormStore.updateData('roomNum', targetNewNum)
  //     // console.log('target更新済み', target.data(this.target))
  //   }

  //   peopleMinusClick() {
  //     console.log('peopleMinusClick')
  //     // this.target = this.formName.replace('Plus', '').replace('Minus', '')
  //     // const target = this.$element.parent().find('#' + this.target)
  //     // const targetNum = target.data(this.target)
  //     // const targetNewNum = targetNum - 1
  //     // FormStore.updateData('roomNum', targetNewNum)
  //     // this.trigger('tourDetailRoomAllocation')
  //     // target.data(this.target, targetNewNum)
  //     // target.html(targetNewNum)
  //   }

  render() {
    console.log('render')
    this.peopleDisable(this.formName)
    console.log(this.formName)
    // this.option()
    // const val = String(FormStore.getData(this.formName))
    // this.$element.val(val)
  }

  roomRender() {
    console.log(11111111111)
    console.log(this.formName)
    this.$element
      .parent()
      .find('.plus_count_room[name=' + this.formName + ']')
      .on('click', () => this.peoplePlusClick())
    this.$element
      .parent()
      .find('.minus_count_room[name=' + this.formName + ']')
      .on('click', () => this.peopleMinusClick())
    // this.option()
    // const val = String(FormStore.getData(this.formName))
    // this.$element.val(val)
  }

  peopleDisable(people) {
    console.log('peopleDisable', people)
    this.targetpeople = people.replace('Plus', '').replace('Minus', '')
    const target = this.$element.parent().find('.' + this.targetpeople)
    const targetNum = UiStore.getData('allRooms.' + people, 0)
    // target.data(people, targetNum)
    // target.html(targetNum)
    console.log('this.target', this.targetpeople)
    console.log('targetNewNum', targetNum)
    console.log(people, targetNum)

    if (UiStore.getData(people, 0) === 0) {
      UiStore.updateData(people, 0)
    }
    if (UiStore.getData(people, 0) === 0) {
      $('.minus_count_people[name=' + people + ']').addClass(this.disableClass)
    }
    // if (UiStore.getData(`minusDisable`, false) === true) {
    //   $('.minus_count_people').addClass(this.disableClass)
    // } else {
    //   $('.minus_count_people').removeClass(this.disableClass)
    // }

    console.log('peopleDisable::info', UiStore.getData(people, 0))
    // if (UiStore.getData(`roomPlusDisable`, false) === true) {
    //   $('.plus_count').addClass(this.disableClass)
    // } else {
    //   $('.plus_count').removeClass(this.disableClass)
    // }
    // if (UiStore.getData(`roomMinusDisable`, false) === true) {
    //   $('.minus_count').addClass(this.disableClass)
    // } else {
    //   $('.minus_count').removeClass(this.disableClass)
    // }
    // console.log('roomPlusDisable', UiStore.getData(`roomPlusDisable`))
    // console.log('roomMinusDisable', UiStore.getData(`roomMinusDisable`))
  }
}
